import { ModalProps } from '@billy/design-system'
import React, { ReactElement } from 'react'

import { ReconciliationSuggestion } from '@modules-deprecated/bankReconciliation/types'

import {
  BankLinesContextProvider,
  BankLinesFilteringContextProvider,
  ContactBalanceContextProvider,
  ManualPaymentContextProvider,
  MatchContextProvider,
  ModalContentsOperationsContextProvider,
  MultiplePayableSubjectsContextProvider,
  PaymentModalContextProvider,
} from '../../contexts'
import { PayableSubject } from '../../types'
import { getTypeFromPayableSubject } from '../../utils'

export interface PaymentReconciliationModalWrapperProps<T extends PayableSubject> extends ModalProps {
  currentSubject: T
  children?: ReactElement
  isLoading: boolean
  subjects?: T[]
  suggestions?: ReconciliationSuggestion[]
  isCashBasis?: boolean
}

export const PaymentReconciliationModalWrapper = <T extends PayableSubject>({
  currentSubject,
  children,
  isLoading,
  subjects,
  suggestions,
  isCashBasis,
  ...modalProps
}: PaymentReconciliationModalWrapperProps<T>): ReactElement => {
  return (
    <PaymentModalContextProvider subject={currentSubject} modalId={modalProps.id}>
      <ContactBalanceContextProvider
        contactId={currentSubject?.contactId || undefined}
        currencyId={currentSubject?.currencyId || undefined}
        subjectType={getTypeFromPayableSubject(currentSubject)}
      >
        <MultiplePayableSubjectsContextProvider<T>
          initialSubject={currentSubject}
          isLoading={isLoading}
          subjects={subjects}
          isCashBasis={isCashBasis}
        >
          <MatchContextProvider suggestions={suggestions}>
            <BankLinesFilteringContextProvider>
              <BankLinesContextProvider>
                <ManualPaymentContextProvider>
                  <ModalContentsOperationsContextProvider>{children}</ModalContentsOperationsContextProvider>
                </ManualPaymentContextProvider>
              </BankLinesContextProvider>
            </BankLinesFilteringContextProvider>
          </MatchContextProvider>
        </MultiplePayableSubjectsContextProvider>
      </ContactBalanceContextProvider>
    </PaymentModalContextProvider>
  )
}
